/**
 * section-sw-pdp-features.js — numbered feature module (P-11).
 *
 * Click sync: always on, plain JS + CSS transitions (works with zero GSAP,
 * instant under prefers-reduced-motion).
 * Scroll sync: desktop >=1024px only, registered THROUGH the SWAnimations
 * gate — ScrollTrigger onEnter/onEnterBack per entry, no pins (c6 X-04).
 *
 * Both mechanics stay INSIDE the section root: entries carry
 * [data-feature-target], layers carry [data-feature-layer]. This module
 * deliberately does not use [data-image-target], which belongs to the
 * PDP gallery's cross-section contract.
 */
(function () {
  'use strict';
  if (window.SWPdpFeatures) return;
  window.SWPdpFeatures = true;

  function activate(root, target) {
    if (!target) return;
    var found = false;
    root.querySelectorAll('[data-feature-layer]').forEach(function (layer) {
      var match = layer.getAttribute('data-feature-layer') === target;
      layer.classList.toggle('is-current', match);
      if (match) found = true;
    });
    if (!found) return;
    root.querySelectorAll('[data-sw-feature]').forEach(function (entry) {
      entry.classList.toggle('is-active', entry.getAttribute('data-feature-target') === target);
    });
  }

  function init(root) {
    if (root.hasAttribute('data-sw-features-ready')) return;
    root.setAttribute('data-sw-features-ready', '');
    root.addEventListener('click', function (event) {
      var head = event.target.closest('.sw-feature__head');
      if (!head) return;
      var entry = head.closest('[data-sw-feature]');
      if (!entry) return;
      activate(root, entry.getAttribute('data-feature-target'));
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sw-features]').forEach(init);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  if (window.SWAnimations) {
    window.SWAnimations.register('sw-pdp-features-sync', '[data-sw-animate="pdp-features"]', function (el, gsap) {
      if (!window.ScrollTrigger || typeof gsap.matchMedia !== 'function') return;
      var mm = gsap.matchMedia();
      mm.add('(min-width: 1024px)', function () {
        var triggers = [];
        el.querySelectorAll('[data-sw-feature]').forEach(function (entry) {
          var target = entry.getAttribute('data-feature-target');
          if (!target) return;
          triggers.push(
            window.ScrollTrigger.create({
              trigger: entry,
              start: 'top center',
              onEnter: function () {
                activate(el, target);
              },
              onEnterBack: function () {
                activate(el, target);
              }
            })
          );
        });
        return function () {
          triggers.forEach(function (trigger) {
            trigger.kill();
          });
        };
      });
      return function () {
        mm.revert();
      };
    });
  }
})();
